import { EllipsedText, FlexRow, useMoment } from '@gorila-shared-ui/components';
import { ModalHeader } from 'baseui/modal';
import { HeadingXSmall, LabelMedium, ParagraphSmall } from 'baseui/typography';
import { useStyles } from '../../../../hooks/useStyles';
import { Asset } from '../../../../types/asset';
import { getAssetTitle } from '../../../../utils/assets';

type Props = { asset: Asset };

const StreamingCaptureHeader = ({ asset }: Readonly<Props>) => {
  const { theme, classes } = useStyles();
  const { formatDateFromTs } = useMoment();

  return (
    <ModalHeader>
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={classes.centeredStart}
      >
        <HeadingXSmall margin={0}>{getAssetTitle(asset)}</HeadingXSmall>
        <ParagraphSmall
          margin={0}
          color={theme.colors.contentSecondary}
        >
          <EllipsedText
            breakAll
            inline
          >
            {`(${asset.label})`}
          </EllipsedText>
        </ParagraphSmall>
        <LabelMedium margin={0}>{formatDateFromTs(Date.now())}</LabelMedium>
      </FlexRow>
    </ModalHeader>
  );
};

export default StreamingCaptureHeader;
